import React from 'react';
import { TableColumn } from '@hero/ui-kit/tables/Table';
import P from '@hero/ui-kit/typography/P';
import Tag from '@hero/ui-kit/components/Tag';
import ClickableOpacity from '@hero/ui-kit/inputs/ClickableOpacity';
import { useLocation, useNavigate } from 'react-router-dom';
import DripStatusPill from './DripStatusPill';
import type { DripSummary } from '../../types';
const NameRender: React.FC<{
    drip: DripSummary;
}> = ({ drip }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const handleClick = () => {
        const from = `${location.pathname}${location.search}`;
        navigate(`/mark/drips/${drip.drip_id}`, { state: { from } });
    };
    return (
        <ClickableOpacity
            onClick={handleClick}
            alt="view-drip"
            styles={{
                cursor: 'pointer'
            }}
        >
            <P noDefaultMargin strong>
                <span
                    style={{
                        borderBottom: '1px solid var(--mark-primary)'
                    }}
                >
                    {drip.name}
                </span>
            </P>
        </ClickableOpacity>
    );
};
const getDripColumns = (): TableColumn<DripSummary>[] => [
    {
        colKey: 'name',
        name: 'Name',
        align: 'left',
        headAlign: 'left',
        render: (drip) => <NameRender drip={drip} />
    },
    {
        colKey: 'status',
        name: 'Status',
        align: 'left',
        headAlign: 'left',
        render: (drip) => <DripStatusPill status={drip.status} />
    },
    {
        colKey: 'trigger_type',
        name: 'Trigger',
        align: 'left',
        headAlign: 'left',
        render: (drip) => (
            <Tag type={drip.trigger_type === 'PROSPECT' ? 'warn' : 'primary'} size="small">
                {drip.trigger_type}
            </Tag>
        )
    },
    {
        colKey: 'enrollment_segment_name',
        name: 'Audience',
        align: 'left',
        headAlign: 'left',
        render: (drip) => (
            <P noDefaultMargin>
                {drip.enrollment_segment_name ?? (
                    <Tag type="warn" size="small">
                        {drip.trigger_type === 'PROSPECT' ? 'PROSPECT' : '—'}
                    </Tag>
                )}
            </P>
        )
    },
    {
        colKey: 'enrolled_count',
        name: 'Enrolled',
        align: 'right',
        headAlign: 'right',
        render: (drip) => (
            <P noDefaultMargin styles={{ textAlign: 'right', width: '100%' }}>
                {drip.enrolled_count.toLocaleString()}
            </P>
        )
    },
    {
        colKey: 'active_count',
        name: 'Active',
        align: 'right',
        headAlign: 'right',
        render: (drip) => (
            <P noDefaultMargin styles={{ textAlign: 'right', width: '100%' }}>
                {drip.active_count.toLocaleString()}
            </P>
        )
    }
];
export default getDripColumns;
